<script setup lang="ts">
import { ref, onMounted, computed, onBeforeUnmount, defineProps } from "vue";
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/ar';

const props = defineProps<{
  fontFamily: string;
  fontSize: number;
  fontColor: string;
  fontWeight: string;
}>();

// const language = ref("en");
// const getLanguage=()=>{
//   const lang = localStorage.getItem("Language") || "en";
//   if(lang == "fr"){
//     language.value = "fr";
//     moment.locale('fr');
//   }else if(lang == "ar"){
//     language.value = "ar";
//     moment.locale('ar');
//   }else {
//     language.value = "en";
//     moment.locale('en');
//   }
// }

const currentDate = ref(new Date());
const dateTimer = ref<number | null>(null);

const formattedDate = computed(() => {
  return moment(currentDate.value).locale('fr').format('dddd D MMM, YYYY').replace(/^([a-zA-Z])/,
    (match) => match.toUpperCase()
  );
  // if (language.value === 'ar') {
  //   const date = moment(currentDate.value).locale('ar');
  //   //format date as arabic 
  //   const formatted = date.format('dddd D MMMM، YYYY');
  //   //replace arabic digits with latin
  //   return formatted.replace(/[٠-٩]/g, d => '0123456789'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)]);
  // }
  // //default format for other langs
  // return moment(currentDate.value).format('dddd D MMM, YYYY').replace(/^([a-zA-Z])/,
  //   (match) => match.toUpperCase()
  // );
});

onMounted(() => {
  // getLanguage();
  moment.locale('fr'); 
  updateDate();
  // update date every minute
  dateTimer.value = window.setInterval(updateDate, 60000);
});

onBeforeUnmount(() => {
  if (dateTimer.value) {
    window.clearInterval(dateTimer.value);
  }
});

function updateDate() {
  currentDate.value = new Date();
}
</script>

<script lang="ts">
export default {
  name: "DateWidget",
};
</script>

<template>
  <div
    class="date-widget"
    :style="{
      fontFamily: fontFamily,
      fontSize: `${fontSize}px`,
      color: fontColor,
      fontWeight: fontWeight === 'bold' ? 'bold' : 'normal',
      fontStyle: fontWeight === 'italic' ? 'italic' : 'normal',
      textDecoration: fontWeight === 'underline' ? 'underline' : 'none',
    }"
  >
    {{ formattedDate }}
  </div>
</template>

<style scoped>
.date-widget {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
  padding: 10px;
}
</style>
